import {
  type ShortReservation,
  type BookingSummary,
  ACCESS_TIME_STATUS,
} from '@chekin/core';

function getShortTime(time?: string) {
  return time?.substring(0, 5);
}

type TimeSelector = (
  reservation: ShortReservation,
  summary: BookingSummary,
) => {customTime?: string; defaultTime?: string};

export const checkInTimeSelector = (
  reservation: ShortReservation,
  summary: BookingSummary,
) => ({
  customTime: summary?.access_start_time,
  defaultTime: reservation?.access_start_time,
});

export const checkOutTimeSelector = (
  reservation: ShortReservation,
  summary: BookingSummary,
) => ({
  customTime: summary?.access_end_time,
  defaultTime: reservation?.access_end_time,
});

export const isNoHours = (summary?: BookingSummary) => {
  return Boolean(
    !summary?.is_remote_access_enabled ||
      summary?.access_time_status === ACCESS_TIME_STATUS.disabled,
  );
};

export const getTime =
  (reservation: ShortReservation, summary: BookingSummary) =>
  (selector: TimeSelector) => {
    if (isNoHours(summary)) {
      return undefined;
    }
    const {customTime, defaultTime} = selector(reservation, summary);

    if (summary.access_time_status === ACCESS_TIME_STATUS.custom) {
      return getShortTime(customTime);
    }
    return getShortTime(defaultTime);
  };
